// src/pages/Photos.jsx
import React, { useState } from "react";
import PhotoGallery from "../components/PhotoGallery";
import { photos } from "../data/photos";
import styles from "./Photos.module.css";

const getTopLevelFolders = () => {
  const folders = new Set();
  photos.forEach((photo) => {
    const topFolder = photo.url.split("/")[2];
    if (topFolder) {
      folders.add(topFolder);
    }
  });
  return Array.from(folders).sort();
};

function Photos() {
  const [currentFolder, setCurrentFolder] = useState(null);
  const topLevelFolders = getTopLevelFolders();

  const handleFolderClick = (folderName) => {
    setCurrentFolder(folderName);
  };

  const handleBackClick = () => {
    setCurrentFolder(null);
  };

  const filteredPhotos = currentFolder
    ? photos.filter((photo) => photo.url.split("/")[2] === currentFolder)
    : [];

  return (
    <div className={styles.photosPage}>
      <h1>The Rhatigan Family Album</h1>
      <p>Browse through all our treasured memories.</p>

      {!currentFolder ? (
        <div className={styles.folderList}>
          {topLevelFolders.map((folder) => (
            <button
              key={folder}
              onClick={() => handleFolderClick(folder)}
              className={styles.folderButton}
            >
              {folder}
            </button>
          ))}
        </div>
      ) : (
        <>
          <button onClick={handleBackClick} className={styles.backButton}>
            &larr; Back to Folders
          </button>
          <h2>{currentFolder}</h2>
          <PhotoGallery photos={filteredPhotos} />
        </>
      )}
    </div>
  );
}

export default Photos;
